import Vue from 'vue';
import Router from 'vue-router';
import InvitationScreen from '@/components/invitations/InvitationScreen';

const Competition = () => import('@/components/competition/Competition');
const Transactions = () => import('@/components/transactions/Transactions');
const ProfileScreen = () => import('@/components/profile/ProfileScreen');
const UserProfileScreen = () => import('@/components/profile/UserProfileScreen');
const TeamSettingsScreen = () => import('@/components/team/TeamSettingsScreen');
const HistoryScreen = () => import('@/components/history/HistoryScreen');
const EmbeddedScreen = () => import('@/components/embedded/EmbeddedScreen');
const AuthenticateScreen = () => import('@/components/authenticate/Authenticate');
const ResetPasswordScreen = () => import('@/components/authenticate/ResetPasswordScreen');
const PrivacyPolicyScreen = () => import('@/components/law/PrivacyPolicyScreen');
const TermsOfServiceScreen = () => import('@/components/law/TermsOfServiceScreen');
const RegistrationScreen = () => import('@/components/registration/RegistrationScreen');
const ReportDetailsScreen = () => import('@/components/team/ReportDetailsScreen');
const InstantRegistrationScreen = () => import('@/components/registration/InstantRegistrationScreen');
const AppSumoFinalizeScreen = () => import('@/components/registration/AppSumoFinalizeScreen');
const ThankScreen = () => import('@/components/kudos/ThankScreen');

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Competition',
      component: Competition,
    },
    {
      path: '/kick-off',
      name: 'Competition',
      component: Competition,
      meta: {
        kickOff: true,
      },
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: Transactions,
    },
    {
      path: '/profile',
      name: 'ProfileScreen',
      component: ProfileScreen,
    },
    {
      path: '/users/:id',
      name: 'UserProfileScreen',
      component: UserProfileScreen,
    },
    {
      path: '/team',
      name: 'TeamSettingsScreen',
      component: TeamSettingsScreen,
    },
    {
      path: '/companies/:companyId/reports/:id',
      name: 'ReportDetailsScreen',
      component: ReportDetailsScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/history',
      name: 'HistoryScreen',
      component: HistoryScreen,
    },
    {
      path: '/embedded/:externalApiKey',
      name: 'EmbeddedScreen',
      component: EmbeddedScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/invitations/:code',
      name: 'InvitationScreen',
      component: InvitationScreen,
      meta: {
        isCompanyInvitation: false,
        isPublic: true,
      },
    },
    {
      path: '/c/:code',
      name: 'InvitationScreen',
      component: InvitationScreen,
      meta: {
        isCompanyInvitation: true,
        isPublic: true,
      },
    },
    {
      path: '/login',
      name: 'AuthenticateScreen',
      component: AuthenticateScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/reset-password/:code',
      name: 'ResetPasswordScreen',
      component: ResetPasswordScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyScreen',
      component: PrivacyPolicyScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServiceScreen',
      component: TermsOfServiceScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/registration',
      name: 'RegistrationScreen',
      component: RegistrationScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/instant',
      name: 'InstantRegistrationScreen',
      component: InstantRegistrationScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/appsumo/:uuid/finalize',
      name: 'AppSumoFinalizeScreen',
      component: AppSumoFinalizeScreen,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/kudos/:code',
      name: 'ThankScreen',
      component: ThankScreen,
      meta: {
        isPublic: true,
      },
    },
    { path: '*', redirect: '/' },
  ],
});
